const TEMP_ACCOUNT_STATUS = {
    APPROVED: 'APPROVED',
    DOCUMENTS_NOT_RECEIVED: 'DOCUMENTS_NOT_RECEIVED',
    PENDING_VERIFICATION: 'PENDING_VERIFICATION'
};
export {TEMP_ACCOUNT_STATUS};